module.exports = __webpack_public_path__ + "89abd584b2649955398be1db443324ae.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/sofas/sofa-beach.png
// module id = 3423
// module chunks = 0